// src/firebase.js
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'


// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyB4DNoJEdzGLxmT-gMPzQcdlK2Mn2BHzHw",
    authDomain: "codini-2-0.firebaseapp.com",
    projectId: "codini-2-0",
    storageBucket: "codini-2-0.firebasestorage.app",
    messagingSenderId: "321039990665",
    appId: "1:321039990665:web:7d9ac3097aa98bede22b58",
    measurementId: "G-1S8VC5JR8H"
};
  


const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app) // <-- Storage referansı